import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { GdprWidgetStep } from './types';
import {
  PapiRequestSettingsGdprConfirmRemove,
  PapiRequestSettingsGdprRequestData,
  PapiRequestSettingsGdprRequestRemove,
  PapiRequestSettingsGdprResendLink,
  PapiRequestSettingsGdprResendRemoveConfirmation,
  PapiSettingsGdprConfirmRemove,
  PapiSettingsGdprRequestData,
  PapiSettingsGdprRequestRemove,
  PapiSettingsGdprResendLink,
  PapiSettingsGdprResendRemoveConfirmation,
} from '@wix/da-papi-types';
import {
  createNetworkRequestActionSet,
  createNetworkRequestActionSetWithSuppliedData,
} from '../utils';

export const setGdprWidgetStep = createAction(
  `${reduxKey}.SET_GDPR_WIDGET_STEP`,
  (step: GdprWidgetStep) => ({ step })
);

export const {
  submit: submitPersonalDataRequest,
  success: submitPersonalDataRequestSuccess,
  failure: submitPersonalDataRequestFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettingsGdprRequestData,
  PapiSettingsGdprRequestData
>(reduxKey, 'SUBMIT_PERSONAL_DATA_REQUEST');

export const {
  submit: submitPersonalDataRemoveRequest,
  success: submitPersonalDataRemoveRequestSuccess,
  failure: submitPersonalDataRemoveRequestFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettingsGdprRequestRemove,
  PapiSettingsGdprRequestRemove
>(reduxKey, 'SUBMIT_PERSONAL_DATA_REMOVE_REQUEST');

export const {
  submit: submitPersonalDataConfirmRemoval,
  success: submitPersonalDataConfirmRemovalSuccess,
  failure: submitPersonalDataConfirmRemovalFailure,
} = createNetworkRequestActionSet<
  PapiRequestSettingsGdprConfirmRemove,
  PapiSettingsGdprConfirmRemove
>(reduxKey, 'SUBMIT_PERSONAL_DATA_CONFIRM_REMOVAL');

export const {
  submit: submitPersonalDataResendDownloadLink,
  success: submitPersonalDataResendDownloadLinkSuccess,
  failure: submitPersonalDataResendDownloadLinkFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettingsGdprResendLink,
  PapiSettingsGdprResendLink
>(reduxKey, 'SUBMIT_PERSONAL_DATA_RESEND_DOWNLOAD_LINK');

export const {
  submit: submitPersonalDataResendDataRemovalConfirmationLink,
  success: submitPersonalDataResendDataRemovalConfirmationLinkSuccess,
  failure: submitPersonalDataResendDataRemovalConfirmationLinkFailure,
} = createNetworkRequestActionSet<
  PapiRequestSettingsGdprResendRemoveConfirmation,
  PapiSettingsGdprResendRemoveConfirmation
>(reduxKey, 'SUBMIT_PERSONAL_DATA_RESEND_DATA_REMOVAL_CONFIRMATION_LINK');
